import { ImperialParser } from "./ImperialParser";
const precision = 64;
export class ImperialDistance {
    constructor(sixtyFourths) { this.sixtyFourthsOfInch = void 0; this.sixtyFourthsOfInch = Math.round(sixtyFourths); }
    simplifySixtyFourths(n) { const value = Math.abs(n); if (value === 0)
        return ""; if (value >= 64)
        throw new Error("value must be less than 64"); const div = this.gcd(value, 64); return value / div + "/" + 64 / div; } // gcd get's the greatest common divisor of the two numbers
    gcd(a, b) { if (a === 0 || b === 0)
        throw new Error("can't find GCD of zero"); if (a === b)
        return a; if (b > a)
        return this.gcd(b, a); let total = a; let mul = b; for (let k = 0; k < a; k++) {
        const remainder = this.gcdGetRemainder(total, mul);
        if (remainder === 0)
            return mul;
        total = mul;
        mul = remainder;
    } throw new Error("unable to calculate gcd"); }
    gcdGetRemainder(total, mul) { while (total >= mul) {
        total -= mul;
    } return total; }
    toString() { let parts = []; const base = Math.abs(this.sixtyFourthsOfInch); const isNeg = this.sixtyFourthsOfInch < 0; let totalInches = Math.floor(base / precision); const sub = Math.round((base - totalInches * precision) / precision * 64); const subStr = this.simplifySixtyFourths(sub); const inches = totalInches % 12; if (subStr === "") {
        parts.push(inches.toString());
    }
    else {
        parts.push(inches + " " + subStr);
    } totalInches -= inches; const ft = Math.floor(totalInches / 12); parts.push(ft + "'"); return (isNeg ? "-" : "") + parts.reverse().join(""); }
    toInchesString() { let parts = []; const base = Math.abs(this.sixtyFourthsOfInch); const isNeg = this.sixtyFourthsOfInch < 0; let totalInches = Math.floor(base / precision); const sub = Math.round(base - totalInches * precision); const subStr = this.simplifySixtyFourths(sub); const inches = totalInches; if (inches !== 0) {
        if (subStr === "") {
            parts.push(inches + '"');
        }
        else {
            parts.push(inches + " " + subStr + '"');
        }
    }
    else {
        if (subStr !== "") {
            parts.push(subStr + '"');
        }
    } return (isNeg ? "-" : "") + parts.reverse().join(" "); }
    universalValue() { return this.sixtyFourthsOfInch / precision * ImperialDistance.unitsPerInch; }
    static fromUniversal(n) { const v = n / ImperialDistance.unitsPerInch * precision; return new ImperialDistance(v); }
    inches() { return Math.floor(this.sixtyFourthsOfInch / precision); }
    rounded() { return new ImperialDistance(Math.round(this.sixtyFourthsOfInch / 64) * 64); }
    getValue() { return this.sixtyFourthsOfInch; }
    static fromFeetAndInches(input) { return new ImperialDistance((input.feet || 0) * 12 * precision + (input.inches || 0) * precision); }
    static parse(value) { const parsed = ImperialParser.parse(value); return ImperialDistance.fromFeetAndInches(parsed); }
    add(other) { return ImperialDistance.fromUniversal(this.universalValue() + other.universalValue()); }
    static show(units, options) { let value = ImperialDistance.fromUniversal(units); if (options !== null && options !== void 0 && options.rounded) {
        value = value.rounded();
    } return value.toString(); }
    static showInches(units) { const len = ImperialDistance.fromUniversal(units); return len.toInchesString(); }
} // see dim/main.go
ImperialDistance.unitsPerInch = 254 * 64;
